import { Box, Divider, Flex, Link, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ContractDataFieldNameDto } from "../../../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../../../common/auth/useLoggedInWithOrgContextState";
import { ContractState } from "../../../../common/redux/reducers/contractReducer";
import { urls } from "../../../../urls";
import { requireDataFields } from "../../typeguards";

interface Props {
  data: ContractState["contract"];
}

const originSourcingEventUrl = (
  sourcingEvent: { id: string; type: string },
  viewerIsOwner: boolean,
): string => {
  if (!viewerIsOwner) return urls.v2.supplier.procurement.go(sourcingEvent.id);
  return sourcingEvent.type === "SourcingEventV2"
    ? urls.v2.sourcingEvents.view.go(sourcingEvent.id)
    : urls.events.view.go(sourcingEvent.id);
};

export const OriginSourcingEvent = ({ data }: Props) => {
  const { t } = useTranslation();
  const { selectedOrg } = useLoggedInWithOrgContextState();
  const dataFields = requireDataFields(data);
  const sourcingEvent = dataFields.originSourcingEvent;
  const addedDataFields = dataFields.addedDataFields.map((e) => e.name);
  const viewerIsOwner = data.owningOrganizationId === selectedOrg.id;

  if (addedDataFields.includes(ContractDataFieldNameDto.OriginSourcingEvent) && !sourcingEvent) {
    return (
      <Box padding="15px" paddingBottom={"20px"} w="100%">
        <Text fontWeight={"bold"} fontSize="sm" color="#808B9B">
          {t("Origin sourcing event")}
        </Text>
        <Divider marginTop={"5px"} marginBottom={"5px"} />
        <Text fontStyle={"italic"}>{t("Not provided")}</Text>
      </Box>
    );
  }

  if (!sourcingEvent) {
    return null;
  }

  return (
    <Box padding="15px" paddingBottom={"20px"} w="100%">
      <Text fontWeight={"bold"} fontSize="sm" color="#808B9B">
        {t("Origin sourcing event")}
      </Text>
      <Divider marginTop={"5px"} marginBottom={"5px"} />
      <Flex mt="7px" key={sourcingEvent.id}>
        <Link href={originSourcingEventUrl(sourcingEvent, viewerIsOwner)} color="blue.500" target="_blank">
          {sourcingEvent.title}
        </Link>
      </Flex>
    </Box>
  );
};
